import axios from "../../axios.js";

const getAllParameters = ({ commit }) => {
  const url = `/api/parameter/allWithoutTimes`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_PARAMETERS", response);
    })
    .catch((err) => {
      console.log(err.response);
    });
};
const getAllPriceConverters = ({ commit }) => {
  const url = `/api/priceConverter`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_PRICE_CONVERTERS", response.data);
    })
    .catch((err) => {
      console.log(err.response);
    });
};

const updateParameter = ({ commit, dispatch }, data) => {
  const url = `/api/parameter/update`;
  let body = {
    variable: data.variable,
    value: data.value,
  };
  axios
    .post(url, body)
    .then((response) => {
      commit("UPDATE_PARAMETER_SUCCESS", response.data.message);
      let body = {
        token: data.token,
      };
      dispatch("getAllParameters", body);
    })
    .catch((err) => {
      commit("UPDATE_PARAMETER_SUCCESS", err.response.data.message);
    });
};

export default {
  getAllParameters,
  updateParameter,
  getAllPriceConverters
};
